import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'web-interactives-dashboard-ui/actions/ModalActions';
import { getIsModalOpenWithProps } from 'web-interactives-dashboard-ui/selectors/modalSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
function withModalProps(Component, modalType) {
  return function WrappedComponent(props) {
    const dispatch = useDispatch();
    const onClose = () => dispatch(closeModal());
    const {
      isOpen,
      props: stateProps
    } = useSelector(state => getIsModalOpenWithProps(state, modalType));
    const hocProps = {
      onClose,
      isOpen
    };
    const allProps = Object.assign({}, props, stateProps, hocProps);
    if (!isOpen) return null;
    return /*#__PURE__*/_jsx(Component, Object.assign({}, allProps));
  };
}
export default withModalProps;